import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { ESTADO_LABELS, ORIGEN_LABELS, PRIORIDAD_LABELS } from "../rolloFormat";
import { VISTAS } from "../rolloFilters";
import { FilterSelect } from "../../crmpostventa-shared/components/FilterFields";

const toOptions = (labels, codes) => codes.map((code) => ({ value: code, label: labels[code] }));

const ESTADO_OPTIONS = toOptions(ESTADO_LABELS, ["SOLICITADO", "EN_PREPARACION", "EN_CAMINO"]);
// Only the priorities the backend assigns (creation sets Alta or Media).
const PRIORIDAD_OPTIONS = toOptions(PRIORIDAD_LABELS, ["ALTA", "MEDIA"]);
const RESULTADO_OPTIONS = toOptions(ESTADO_LABELS, ["ENTREGADO", "CANCELADO"]);
const ORIGEN_OPTIONS = toOptions(ORIGEN_LABELS, ["ASESOR"]);

export const FILTER_PANEL_ID = "crm-rollo-filter-panel";

function CierreRange({ filters, today, onChange }) {
  return (
    <div className="crm-rollo__range" role="group" aria-label="Fecha de cierre">
      <span className="crm-rollo__range-label" aria-hidden="true">
        Cierre
      </span>
      <input
        type="date"
        className={`crm-rollo__input${filters.cierreDesde ? " is-set" : ""}`}
        aria-label="Cierre desde"
        value={filters.cierreDesde}
        max={filters.cierreHasta || today}
        onChange={(event) => onChange("cierreDesde", event.target.value)}
      />
      <span className="crm-rollo__range-sep" aria-hidden="true">
        –
      </span>
      <input
        type="date"
        className={`crm-rollo__input${filters.cierreHasta ? " is-set" : ""}`}
        aria-label="Cierre hasta"
        value={filters.cierreHasta}
        min={filters.cierreDesde || undefined}
        max={today}
        onChange={(event) => onChange("cierreHasta", event.target.value)}
      />
    </div>
  );
}

/**
 * FilterBar: free search, the selects of the current view and "Limpiar filtros". On mobile only the search
 * and a "Filtros (n)" button stay visible; the button unfolds the selects in a two-column panel.
 */
export default function FilterBar({
  vista,
  isMobile,
  searchValue,
  onSearchChange,
  filters,
  onFilterChange,
  responsables,
  provincias,
  today,
  activeCount,
  canClear,
  onClear,
  panelOpen,
  onTogglePanel,
}) {
  const responsableOptions = [
    ...(responsables || []).map((responsable) => ({ value: String(responsable.usuarioId), label: responsable.nombre })),
    { value: "0", label: "Sin asignar" },
  ];
  const provinciaOptions = (provincias || []).map((provincia) => ({ value: provincia, label: provincia }));

  const shared = (
    <>
      <FilterSelect name="responsable" label="Responsable" value={filters.responsable} options={responsableOptions} onChange={onFilterChange} />
      <FilterSelect name="provincia" label="Provincia" value={filters.provincia} options={provinciaOptions} onChange={onFilterChange} />
      <FilterSelect name="origen" label="Origen" value={filters.origen} options={ORIGEN_OPTIONS} onChange={onFilterChange} />
    </>
  );

  const selects =
    vista === VISTAS.FINALIZADAS ? (
      <>
        <FilterSelect name="resultado" label="Resultado" value={filters.resultado} options={RESULTADO_OPTIONS} onChange={onFilterChange} />
        <CierreRange filters={filters} today={today} onChange={onFilterChange} />
        {shared}
      </>
    ) : (
      <>
        <FilterSelect name="estado" label="Estado" value={filters.estado} options={ESTADO_OPTIONS} onChange={onFilterChange} />
        <FilterSelect name="prioridad" label="Prioridad" value={filters.prioridad} options={PRIORIDAD_OPTIONS} onChange={onFilterChange} />
        {shared}
      </>
    );

  const clear = (
    <button type="button" className="crm-rollo__link" disabled={!canClear} onClick={onClear}>
      Limpiar filtros
    </button>
  );

  const search = (
    <label className="crm-rollo__field crm-rollo__search">
      <FontAwesomeIcon icon={faMagnifyingGlass} className="crm-rollo__search-ico" aria-hidden="true" />
      <input
        className="crm-rollo__input"
        type="search"
        value={searchValue}
        placeholder="Buscar por comercio, CUIT o terminal"
        aria-label="Buscar por comercio, CUIT o terminal"
        onChange={(event) => onSearchChange(event.target.value)}
      />
    </label>
  );

  if (!isMobile) {
    return (
      <div className="crm-rollo__filters">
        {search}
        {selects}
        {clear}
      </div>
    );
  }

  return (
    <div className="crm-rollo__filters">
      {search}
      <button
        type="button"
        className="crm-rollo__btn crm-rollo__btn--secondary"
        aria-expanded={panelOpen}
        aria-controls={FILTER_PANEL_ID}
        onClick={onTogglePanel}
      >
        <FontAwesomeIcon icon={faFilter} aria-hidden="true" />
        {`Filtros${activeCount ? ` (${activeCount})` : ""}`}
      </button>
      {panelOpen ? (
        <div id={FILTER_PANEL_ID} className="crm-rollo__filter-panel">
          {selects}
          <div className="crm-rollo__filter-panel-foot">{clear}</div>
        </div>
      ) : null}
    </div>
  );
}
